import { PlanDetailView } from '../../components/FinanceEngineV2/Plans/PlanDetailView';

const PlanDetailV2Screen = () => <PlanDetailView />;

export { PlanDetailV2Screen };
